export const INTERIOR_EXTERIOR = 'interior_exterior';
export const FIRE_RATING = 'fire_rating';
export const SINGLE_DOUBLE = 'single_double';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const THICKNESS = 'thickness';
export const GLASS = 'glass';
export const PROFILE = 'profile';
export const HANDING_SWING = 'handing_swing';
export const JAMB = 'jamb';
export const JAMB_WIDTH = 'jamb_width';
export const HINGE = 'hinge';
export const MACHINING = 'machining';
